import React from 'react';

import { BarCode } from './barCode';
import { Bill } from './bill';
import { InvoiceActions } from './InvoiceActions';
import { Payer } from './payer';
import { Recipient } from './recipient';
import { RecipientData } from './recipientData';
import * as S from './styles';
import { BalanceSheet } from './balanceSheet';

/**
 * BillingDetailedLayout - Detailed template layout (version 2)
 * Displays invoice with an enhanced structure for detailed categories
 * 
 * Order: Payer → Bill → DetailedBalanceSheet
 */
export const BillingDetailedLayout = ({ dataBilling, pdfUrl, pdfLoading, pdfError }) => {
  return (
    <>
      <S.Wrapper className='billing'>
        <S.Container className='billing-title'>
          <S.Title style={{ fontSize: '24px' }}>Fatura</S.Title>
          <S.Spacer className='spacer' style={{ marginTop: '-15px' }} />
        </S.Container>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', gap: '16px' }}>
          <S.Container>
            <Payer dataBilling={dataBilling} />
            <S.Spacer className='spacer spacer-mobile' />
            <Bill dataBilling={dataBilling} />
          </S.Container>
          {dataBilling?.balance && (
            <S.Container className='desktop-only'>
              <BalanceSheet dataBilling={dataBilling} />
            </S.Container>
          )}
        </div>
      </S.Wrapper>
      <S.Wrapper>
        <S.RecipientWrapper>
          <Recipient dataBilling={dataBilling} />
          <S.Container>
            <RecipientData dataBilling={dataBilling} />
            {dataBilling.invoiceStatus === 'Pending' && (
              <S.Spacer className='spacer' />
            )}
          </S.Container>
          {dataBilling.invoiceStatus === 'Pending' && (
            <S.ContainerBarCode>
              <BarCode billingNumber={dataBilling.invoiceBarCode} />
              <InvoiceActions
                className='copy-and-print'
                dataBilling={dataBilling}
                pdfUrl={pdfUrl}
                pdfLoading={pdfLoading}
                pdfError={pdfError}
              />
            </S.ContainerBarCode>
          )}
        </S.RecipientWrapper>
      </S.Wrapper>
      {dataBilling?.balance && (
        <S.Wrapper className='mobile-only'>
          <BalanceSheet dataBilling={dataBilling} />
        </S.Wrapper>
      )}
    </>
  );
};
